export default "__VITE_ASSET__De$mX_KG__"